// extracted by mini-css-extract-plugin
export default {"form":"Edit_form__p6bmt","buttonContainer":"Edit_buttonContainer__mYle0"};